





















































































































































































import Vue from "vue";
import { mapActions, mapGetters, mapState } from "vuex";

import iwEmail from "@/encoding/pages/questions/contactinformations/Email.vue";
import iwPhoneNumber from "@/encoding/pages/questions/contactinformations/PhoneNumber.vue";
import iwGsmNumber from "@/encoding/pages/questions/contactinformations/GsmNumber.vue";
import iwCallingTimes from "@/encoding/pages/questions/contactinformations/CallingTimes.vue";

import iwNewCustomerForm from "@/encoding/pages/questions/contactinformations/NewCustomerForm.vue";

import iwNewCustomerModal from "@/encoding/pages/questions/contactinformations/NewCustomerModal.vue";
import iwChangeCustomerPhoneAlertModal from "@/encoding/pages/questions/contactinformations/ChangeCustomerPhoneAlertModal.vue";
import iwNextPreviousButton from "@/encoding/components/NextPreviousButton.vue";

import { validateCustomerForm } from "@/shared/scripts/ValidateCustomer";

import { updateClassified, validationClassified } from "@/shared/scripts/ValidateData";
import { getObjetIndexByKey } from "@/shared/scripts/helpers/array";
import { pushPageViewEvent } from "@/shared/store/modules/gtm/datalayer";
import { i18n } from "@/shared/scripts/helpers/translation/i18n";
import { Customer } from "@/shared/interfaces/customer/Customer.interface";
import {
    hasValidBillboardBillingAddress,
    isBillboardSelected
} from "@/shared/scripts/helpers/customer/billingAddress";
import { removeBillboardAndNotify } from "@/optimizedEncoding/scripts/helpers/billboardEligibility";

export default Vue.extend({
    components: {
        iwEmail: iwEmail,
        iwPhoneNumber: iwPhoneNumber,
        iwGsmNumber: iwGsmNumber,
        iwCallingTimes: iwCallingTimes,
        iwNewCustomerForm: iwNewCustomerForm,
        iwNewCustomerModal: iwNewCustomerModal,
        iwChangeCustomerPhoneAlertModal: iwChangeCustomerPhoneAlertModal,
        iwNextPreviousButton: iwNextPreviousButton
    },

    data: function() {
        return {
            selectedCustomerIndex: null as string | number | null,
            error: "",
            loginEmail: "",
            loginPassword: "",
            loginRemember: false,
            isSubmitButtonDisabled:false,
            isSubscriptionDisplay: false,
            newCustomerModalVisible: false,
            appIsReady: false,
            isButtonDisabled: false as boolean,
            validationChecking: false,
            billboardAddressError: "",
            isBillingAddressInvalid: false,
        };
    },

    computed: {
        ...mapState("CustomersModule", [
            "currentCustomer",
            "customers",
            "isChangeCustomerPhoneAlertModalVisible",
            "isCustomerContactDetailsChange"
        ]),
        ...mapState("UserModule", ["user"]),
        ...mapGetters({
            hasApiErrors: "FormModule/hasErrors",
            isLogged: "UserModule/isLogged",
        }),
        isEditionMode: function(): boolean {
            return this.$store.getters["FormModule/getIsEditionMode"];
        },
        isLoginModalOpen: function(): boolean {
            return this.$store.getters["ModalModule/isModalOpen"];
        },
        customerFormError: function(): string | undefined {
            const errors = this.$store.state.CustomersModule.customerFormError;

            if (errors) {
                return errors.customers;
            }

            return;

        },
        errorCustomer: function(): boolean {
            return this.$store.getters["FormModule/getValueUI"]("error.customer") || false;
        },
    },

    watch: {
        selectedCustomerIndex:  function(value) {
            if (value >= 0) {
                this.$store.commit("CustomersModule/selectCurrentCustomer", value);
                this.$store.commit("CustomersModule/setInitialCustomer", this.customers[value]);
                this.isBillingAddressInvalid = false;
                this.billboardAddressError = "";
            }
        },
    },

    mounted: function() {
        if(!this.isLogged) {
            const successCallback = () => {
                this.getUserCustomers();
            };

            const cancelCallback = () => {
                this.goToPreviousStep();
            };
            this.$store.commit("ModalModule/openLoginModal",{
                successCallback: successCallback,
                cancelCallback: cancelCallback
            });
        } else {
            this.getUserCustomers();
        }

        pushPageViewEvent("classified_deposit_step11_contact_details");
    },

    methods: {
        ...mapActions("CustomersModule", ["createCustomer", "updateCustomer", "getCustomers"]),
        ...mapActions({
            goToPreviousStep: "StepsWizard/previous",
            goToNextStep: "StepsWizard/next"
        }),
        closeLoginModal: function() {
            this.$store.commit("ModalModule/closeModal");
        },
        openLoginModal: function() {
            this.$store.commit("ModalModule/openModal");
        },
        openNewCustomerModal: function() {
            this.newCustomerModalVisible = true;
            this.isBillingAddressInvalid = false;
        },
        closeNewCustomerModal: function() {
            this.newCustomerModalVisible = false;
        },
        preselectCustomer: function() {
            if (this.currentCustomer) {
                this.$store.commit("CustomersModule/setInitialCustomer", this.currentCustomer);
                this.selectedCustomerIndex = getObjetIndexByKey(this.customers, "id", this.currentCustomer.id);
            } else if (this.customers.length === 1) {
                this.$store.commit("CustomersModule/setInitialCustomer", this.customers[0]);
                this.$store.commit("CustomersModule/setCustomerId", this.customers[0].id);
                this.selectedCustomerIndex = 0;
            }
        },
        getUserCustomers: function() {
            this.getCustomers()
                .then(() => {
                    this.preselectCustomer();
                    this.appIsReady = true;
                })
                .catch(() => this.dialog.alert(i18n.t("server_not_responding_error").toString()));
        },
        clickNext: function(){
            this.isButtonDisabled = true;
            this.billboardAddressError = "";
            validateCustomerForm((success:boolean) => {
                Vue.nextTick(() => {
                    const inputsError = document.getElementsByClassName("input--error") as HTMLCollectionOf<HTMLElement>;
                    if (inputsError.length > 0) {
                        inputsError[0].focus();
                        window.scrollTo(0, 0);
                    }
                });
                if (success) {
                    if (this.currentCustomer) {
                        if (!this.validateBillboardAddress(this.currentCustomer)) {
                            this.validationChecking = false;
                            this.isButtonDisabled = false;
                            return;
                        }

                        if (!this.currentCustomer.isNew) {
                            // Edit an allready existing customer
                            if (this.isCustomerContactDetailsChange) {
                                this.validationChecking = false;
                                this.$store.commit("CustomersModule/openChangeCustomerPhoneAlertModal");
                            } else {
                                this.updateCustomer(this.currentCustomer).then(success => {
                                    if(success) {
                                        this.$store.commit("CustomersModule/setIsCustomerContactDetailsChange", false);
                                        // Billing address is now saved to currentCustomer; if it
                                        // resolved to a non-Belgian country, strip the billboard and
                                        // notify before rebuilding the order.
                                        removeBillboardAndNotify();
                                        this.validateAndUpdateClassified();
                                    }
                                })
                                    .catch(() => this.dialog.alert(i18n.t("server_not_responding_error").toString()))
                                    .finally(() => this.validationChecking = false);
                            }
                        }
                    } else {
                        // Create the first customer
                        const newCustomer = this.$store.getters["FormModule/getValueUI"]("customer") as Customer;

                        if (!this.validateBillboardAddress(newCustomer)) {
                            this.validationChecking = false;
                            this.isButtonDisabled = false;
                            return;
                        }

                        this.createCustomer(newCustomer).then(success => {
                            if(success) {
                                // Newly saved billing address may be non-Belgian; strip the
                                // billboard and notify before rebuilding the order.
                                removeBillboardAndNotify();
                                this.validateAndUpdateClassified();
                            } else {
                                this.$store.commit("FormModule/addValueUI", {"path": "error.customer", "value": true});
                                this.validationChecking = false;
                            }
                        }).catch(() => {
                            this.dialog.alert(i18n.t("server_not_responding_error").toString());
                            this.validationChecking = false;
                        });
                    }
                } else {
                    this.validationChecking = false;
                    this.isButtonDisabled  = false;
                }
            });
        },
        clickPrevious: function(){
            this.goToPreviousStep();
        },
        validateBillboardAddress: function(customer: Customer | null): boolean {
            if (!isBillboardSelected(
                this.$store.getters["FormModule/getValueTransaction"],
                this.$store.getters["FormModule/getValueOrder"]
            )) {
                this.isBillingAddressInvalid = false;
                return true;
            }

            if (hasValidBillboardBillingAddress(customer)) {
                this.isBillingAddressInvalid = false;
                return true;
            }

            this.billboardAddressError = this.$t("billboard_complete_billing_address_required") as string;
            this.isBillingAddressInvalid = true;
            this.dialog.alert(this.billboardAddressError);
            return false;
        },
        validateAndUpdateClassified: function() {
            if(this.isEditionMode) {
                this.isButtonDisabled = true;
                validationClassified((isValid: boolean) => {
                    if (!isValid) {
                        this.isButtonDisabled = false;
                        return;
                    }

                    updateClassified((success:boolean) => {
                        Vue.nextTick(() => {
                            this.isButtonDisabled = false;
                            if (success) {
                                let urlTranslated = this.$t("my-immoweb") as string;
                                const to = this.$router.resolve({path: urlTranslated});
                                this.$router.push(to.location);
                            }
                        });
                    });
                });
            } else {
                updateClassified((success:boolean) => {
                    this.isButtonDisabled = true;
                    Vue.nextTick(() => {
                        this.isButtonDisabled = false;
                        if (success) {
                            if(!this.hasApiErrors) {
                                this.$store.commit("ModalModule/openWarningModal");
                            } else {
                                this.goToNextStep();
                            }
                        }
                    });
                });
            }
        }
    }
});

